var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsNoneOn = function SvgPartsNoneOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M27.771 15.886c0 6.564-5.32 11.885-11.885 11.885S4 22.451 4 15.886 9.321 4 15.886 4 27.77 9.321 27.77 15.886"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.481 23.763h3.05v-2.918h-3.05zm5.725-9.885a7.4 7.4 0 0 1-.774 1.262l-1.637 2.15a1.9 1.9 0 0 0-.254.527 2 2 0 0 0-.097.592v.46h-2.875v-.657q0-.702.196-1.207a4.5 4.5 0 0 1 .633-1.075l1.611-2.085q.262-.35.447-.724t.185-.746q0-.768-.472-1.284-.472-.515-1.305-.515-.877 0-1.317.526-.438.527-.439 1.295h-2.852q0-1.01.362-1.832.361-.823.987-1.383a4.5 4.5 0 0 1 1.46-.867 5.2 5.2 0 0 1 1.799-.307q.921 0 1.769.296a4.5 4.5 0 0 1 1.49.856q.64.56 1.017 1.372.376.811.376 1.865 0 .835-.31 1.48"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M6.095 10.667a4.571 4.571 0 1 1 0-9.143 4.571 4.571 0 0 1 0 9.143",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.133 8.7 2.868 6.436l.68-.68L5.133 7.34l3.51-3.51.68.68z",
    clipRule: "evenodd"
  })));
};
export default SvgPartsNoneOn;